<template>
  <div>
    <v-list-item>
      <v-list-item-avatar color="grey">
        <img
          v-if="message.user.avatar_url"
          :src="message.user.avatar_url"
          :alt="name"
      /></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="title">{{ message.title }}</v-list-item-title>
        <v-list-item-subtitle>by {{ name }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <div v-if="message.image_url" class="message__image-wrapper">
      <img :src="message.image_url" />
    </div>
    <v-card-title primary-title>
      <h3 class="body-1">
        <b>{{ message.title }}</b>
      </h3>
    </v-card-title>
    <v-card-text>
      <div>{{ message.message }}</div>
      <div v-if="comments.length > 0" class="message__comments mt-4">
        <v-layout
          v-for="comment in comments"
          :key="comment.id"
          class="message-comment"
          align-center
        >
          <v-avatar size="30px" class="mr-2">
            <img
              v-if="comment.user.avatar_url"
              :src="comment.user.avatar_url"
              :alt="name"
            />
          </v-avatar>
          <div class="message-comment__text">
            <p class="mb-0">
              <strong>{{ name }} - </strong>{{ comment.message }}
            </p>
          </div>

          <v-tooltip left color="error">
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2 mr-0"
                v-on="on"
                @click="openDeleteDialog(comment)"
              >
                <v-icon size="20px" color="error">remove_circle</v-icon>
              </v-btn>
            </template>
            <span>Delete comment</span>
          </v-tooltip>
        </v-layout>
      </div>
    </v-card-text>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-app-bar flat dark color="primary">
          <v-toolbar-title>Are you sure?</v-toolbar-title>
        </v-app-bar>
        <v-card-text class="pt-5">
          If you delete this comment it will be gone forever.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" :loading="loadingDelete" @click="deleteComment()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { commentsCollection } from '@/firebaseConfig';
import getNameFromUser from '@/helpers/getNameFromUser.js';

export default {
  name: 'ViewMessage',
  props: {
    message: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      comments: [],
      currentComment: null,
      deleteDialog: false,
      loadingDelete: false
    };
  },
  computed: {
    name() {
      return getNameFromUser(this.message.user);
    }
  },
  mounted() {
    this.getComments();
  },
  methods: {
    getComments() {
      this.$bind('comments', commentsCollection(this.message.id))
        .then(() => {
          this.loaded = true;
        })
        .catch(error => {
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error loading comments: ${error}`
          });
        });
    },
    openDeleteDialog(comment) {
      this.currentComment = comment;
      this.deleteDialog = true;
    },
    deleteComment() {
      this.loadingDelete = true;
      commentsCollection(this.message.id)
        .doc(this.currentComment.id)
        .delete()
        .then(() => {
          this.deleteDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'success',
            text: 'Comment deleted successfully'
          });
        })
        .catch(error => {
          this.deleteDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error deleting comment: ${error}`
          });
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    }
  }
};
</script>

<style lang="scss">
.message__image-wrapper {
  background-color: #222;
  text-align: center;
  img {
    vertical-align: middle;
    max-height: 280px;
    max-width: 100%;
    width: auto;
    height: auto;
  }
}
.message-comment {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 10px;
  }
  &__text {
    padding: 10px;
    border-radius: 8px;
    background-color: mix(#412c67, #fff, 10%);
  }
}
</style>
